interface CloseSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CloseSVG = ({ color, style }: CloseSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="33"
    viewBox="0 0 31 33"
    fill="none"
  >
    <line
      y1="-1.68919"
      x2="40.8662"
      y2="-1.68919"
      transform="matrix(0.679038 -0.734103 -0.679038 -0.734103 0.0966797 30)"
      stroke="#061838"
      strokeWidth="3.37838"
    />
    <line
      y1="-1.68919"
      x2="40.8662"
      y2="-1.68919"
      transform="matrix(-0.679038 -0.734103 0.679038 -0.734103 30.0967 30)"
      stroke="#061838"
      strokeWidth="3.37838"
    />
  </svg>
);

export default CloseSVG;
